import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["bookSlider"]

  declare readonly bookSliderTarget: HTMLElement

  setBookColor({ detail: { color } }) {
    this.element.style.setProperty("--override-accent-color", color)

    const hex = color.replace(/^\s*#|\s*$/g, "")

    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b

    if (luminance < 128) {
      this.element.style.setProperty("--override-accent-contrast-color", "#ffffff")
    } else {
      this.element.style.setProperty("--override-accent-contrast-color", "#000000")
    }
  }

  setPageLayout({ detail: { pageType, image } }) {
    if (pageType == "front-cover") {
      const pageHost = this.bookSliderTarget.querySelector(
        ":scope [data-slide-type='front-cover'] shadow-page",
      )
      ;(pageHost.shadowRoot.querySelector("#front-cover-image") as HTMLImageElement).src = image
    } else if (pageType == "last-page") {
      const pageHost = this.bookSliderTarget.querySelector(
        ":scope [data-slide-type='last-page'] shadow-page",
      )
      ;(pageHost.shadowRoot.querySelector("#last-page-image") as HTMLImageElement).src = image
    }
  }
}
